export default "__VITE_ASSET__CU6iD3Eu__"